"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var react_1 = __importDefault(require("react"));
var Video = function (props) {
    var _a = props.autoPlay, autoPlay = _a === void 0 ? false : _a, img = props.img, imgAlt = props.imgAlt, _b = props.loop, loop = _b === void 0 ? false : _b, mp4 = props.mp4, ogg = props.ogg, webm = props.webm, rest = __rest(props, ["autoPlay", "img", "imgAlt", "loop", "mp4", "ogg", "webm"]);
    var sources = Object.entries({ mp4: mp4, ogg: ogg, webm: webm }).reduce(function (prev, _a) {
        var ext = _a[0], src = _a[1];
        if (src) {
            return __spreadArray(__spreadArray([], prev, true), [react_1.default.createElement("source", { key: ext, src: src, type: "video/".concat(ext) })], false);
        }
        return prev;
    }, []);
    return (react_1.default.createElement("video", __assign({}, rest, { autoPlay: autoPlay, loop: loop }),
        sources,
        img && imgAlt && react_1.default.createElement("img", { src: img, alt: imgAlt })));
};
exports.Video = Video;
exports.default = exports.Video;
